var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/Migration/SourceClassifierVersions.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from '../../domain';
import { Id } from '../../Id';
import { Version } from '../../Version';
import { EntityVersionData } from './EntityVersionData';
export var UserClassifierVersionsStat = t.recursion('UserClassifierVersionsStat', function () {
  return t.type({
    type: t.literal('UserClassifierVersionsStat'),
    id: Id,
    version: Version,
    dependencies: t.array(EntityVersionData)
  });
});
export var GetSourceClassifiersVersions = ApiCallService.create({
  name: 'getSourceClassifiersVersions',
  parentDomain: ApiDomain,
  result: UserClassifierVersionsStat,
  getKey: ['id', 'version']
});
export var getSourceClassifiersVersions = GetSourceClassifiersVersions.createContext();